import axiosInstance from './axiosInstance'

export interface SkyMobiStatsItem {
  id: string
  user_id: string
  package_name: string
  app_version: string
  country: string
  language: string
  timezone: string
  date: string
  count: number
  createdAt?: string
  updatedAt?: string
}

export class SkyMobiStatsApi {
  static async getList(params?: {
    package_name?: string
    date?: string
    skip?: number
    limit?: number
  }): Promise<{ list: SkyMobiStatsItem[]; total: number }> {
    const response = await axiosInstance.get('/cms/v1/sky-mobi-stats', { params })
    return {
      list: response.data.data.list || [],
      total: response.data.data.total || 0,
    }
  }
}
